import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c9a1b85"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card__expand-trigger"
}
const _hoisted_2 = { class: "card__title-container" }
const _hoisted_3 = { class: "card__title-subcontainer" }
const _hoisted_4 = { class: "card__title" }

import { ref, onMounted } from "vue";
import BtnLink from "@/components/layout/BtnLink.vue";
import IconDownload from "@/assets/icons/icon__download.svg";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    title: {},
    linkText: {},
    linkPath: {},
    downloadLabel: {}
  },
  emits: ["download"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "040336a2": (_unref(height))
}))



let isExpanded = ref<boolean>(true);
let content = ref<HTMLElement>();
let height = ref<string>();

// eslint-disable-next-line
const emit = __emit

onMounted(() => {
  height.value = `${
    content.value != undefined ? content.value.scrollHeight : 0
  }px`;

  //close it once we have the scroll value
  toggleExpansion();
});

function toggleExpansion() {
  isExpanded.value = !isExpanded.value;
}

function handleDownload() {
  emit("download")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["card", { 'card--expand': _unref(isExpanded) }])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
              _renderSlot(_ctx.$slots, "on-title-right")
            ]),
            (_ctx.linkText && _ctx.linkPath)
              ? (_openBlock(), _createBlock(BtnLink, {
                  key: 0,
                  name: _ctx.linkText,
                  path: _ctx.linkPath
                }, null, 8, ["name", "path"]))
              : (_ctx.downloadLabel)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn--blue",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownload()))
                  }, [
                    _createVNode(_unref(IconDownload), { class: "icon icon--black" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.downloadLabel), 1)
                  ]))
                : _createCommentVNode("", true)
          ]),
          (_ctx.$windowWidth < 768)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["plus-sign plus-sign--minus", { 'plus-sign--plus': _unref(isExpanded) }]),
                onClick: toggleExpansion
              }, null, 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "card__content",
          ref_key: "content",
          ref: content
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, _unref(isExpanded) || _ctx.$windowWidth >= 768 || _ctx.title == null]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})